import React from 'react'
import { Tab } from '@Components/TabsWrapperComponent'

interface TabsProps {
    tabs: Tab[]
    onTab(tabName: string): void
    tabsContainerRef: React.RefObject<HTMLDivElement | null>
    activeLineStyle: any
}

const Tabs = (props: TabsProps) => {
    const { tabs, onTab, tabsContainerRef, activeLineStyle } = props

    return (
        <div className="tabs-row">
            <div ref={tabsContainerRef} id="tabs-container" className="tabs-container">
                {tabs
                    .map((tab) => tab)
                    .map((value: Tab, index: number) => (
                        <p key={index} onClick={() => onTab(value.tabName)} className="small bold">
                            {value.tabDisplayName}
                        </p>
                    ))}
            </div>
            <div className="active-line" style={activeLineStyle} />
        </div>
    )
}

export default Tabs
